module.exports = __webpack_public_path__ + "img/0Q3B0162_L_Wood_MockedUp.4f220cdf.jpg";